module.exports = __webpack_public_path__ + "img/dashboard-header.0912b50f.png";